import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { OdinIcon } from '@/components/ui/odin/odin-icon'
import { ThemeToggle } from 'components/chat-page/ThemeToggle'
import { settingsSelectors } from 'store/settings'
import { useModal } from 'providers/ModalProvider'
import { LoginModal } from 'components/modals/LoginModal'
import { useIsAuthModeExternal, useIsAuthModeNoLogin } from 'hooks/useAuthMode'
import { useThemePreference } from 'hooks/useThemePreference'
import { ThemeEnum } from 'types/setting'
import { useLogout } from 'hooks/useLogout'
import { getUserDisplayName, getUserInitial } from 'utils/user'

export const ChatPageSidebarFooter = () => {
  const { t } = useTranslation()
  const currentUser = useSelector(settingsSelectors.userDetails)
  const isLogged = useSelector(settingsSelectors.isLogged)
  const isExternal = useIsAuthModeExternal()
  const isNoLogin = useIsAuthModeNoLogin()
  const isAutoTheme = useThemePreference() === ThemeEnum.Auto
  const { openModal } = useModal()
  const handleLogout = useLogout()

  const showLoginButton = !isLogged && !isExternal && !isNoLogin

  return (
    <div className="flex flex-col gap-2 border-t border-border p-3">
      {isAutoTheme && (
        <div className="flex items-center justify-between px-2.5">
          <span className="text-xs font-medium text-muted-foreground">{t('theme')}</span>
          <ThemeToggle />
        </div>
      )}

      {isLogged && currentUser ? (
        <div className="flex items-center gap-3 rounded-xl bg-muted px-2.5 py-2.5">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-semibold text-primary-foreground">
            {getUserInitial(currentUser)}
          </div>
          <div className="min-w-0 flex-1">
            <div className="truncate text-sm font-medium text-foreground">{getUserDisplayName(currentUser)}</div>
            {currentUser.email && <div className="truncate text-xs text-muted-foreground">{currentUser.email}</div>}
          </div>
          {!isExternal && (
            <button
              type="button"
              onClick={handleLogout}
              title={t('logout')}
              aria-label={t('logout')}
              className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg transition-colors hover:bg-muted"
            >
              <OdinIcon icon={['far', 'sign-out-alt']} className="h-4 w-4 text-muted-foreground" />
            </button>
          )}
        </div>
      ) : showLoginButton ? (
        <button
          type="button"
          onClick={() => openModal(<LoginModal />)}
          className="flex w-full items-center gap-3 rounded-xl bg-muted px-2.5 py-2.5 text-left transition-colors hover:bg-accent"
        >
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary">
            <OdinIcon icon={['far', 'sign-in-alt']} className="h-4 w-4 text-primary-foreground" />
          </div>
          <span className="flex-1 truncate text-sm font-medium text-foreground">{t('login')}</span>
          <OdinIcon icon={['far', 'chevron-right']} className="h-3.5 w-3.5 text-muted-foreground" />
        </button>
      ) : null}
    </div>
  )
}
